import api from "./api";

const cache = new Map();

export function getCompanyModules(adminId) {
  const key = String(adminId);
  const entry = cache.get(key);

  if (entry?.data !== undefined) {
    return Promise.resolve(entry.data);
  }

  if (entry?.promise) {
    return entry.promise;
  }

  const promise = api
    .get(`/companyModules/${adminId}`)
    .then(({ data }) => {
      cache.set(key, { data });
      return data;
    })
    .catch((err) => {
      cache.delete(key);
      throw err;
    });

  cache.set(key, { promise });
  return promise;
}
